<template>
  <section >

    <Empty  :loading="loading" :condition="data == 0" :p_main="'pt-0'" />

    <div v-if="!loading && data.length > 0" class="col-12 p-0">

      <table class="table table-hover table-sm mt-2">
        <thead class="table-secondary">
          <th>Item</th>
          <th class="text-right" v-for="(month, index) in months" :key="index">
            <span v-if="month.type == 'month'">{{ monthHistory(month.month) }}</span>
            <span v-else> General</span>
          </th>
        </thead>

        <tbody>
          <tr v-for="(item, index) in titles" :key="index">
            <td>
              <span :class="mainTitles(item.title)">{{  item.title }}</span>
            </td>

            <template v-if="index == 0">
              <td
                class="text-right font-weight-bold"
                v-for="(item, index) in getItems('total_revenue')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 1">
              <td
                class="text-right"
                v-for="(item, index) in getItems('declined')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 2">
              <td
                class="text-right"
                v-for="(item, index) in getItems('recovery')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 3">
              <td
                class="text-right"
                v-for="(item, index) in getItems('exorenated')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 4">
              <td
                class="text-right"
                v-for="(item, index) in getItems('absent')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 5">
              <td
                class="text-right"
                v-for="(item, index) in getItems('cancel')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 6">
              <td
                class="text-right font-weight-bold"
                v-for="(item, index) in getItems('lost_leads')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 7">
              <td
                class="text-right font-weight-bold"
                v-for="(item, index) in getItems('cashable_revenue')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <!-- <template v-if="index == 8">
              <td
                class="text-right"
                v-for="(item, index) in getItems('domains')" :key="index"
              >
                {{ item }}
              </td>
            </template> -->

            <!-- <template v-if="index == 8">
              <td
                class="text-right"
                v-for="(item, index) in getItems('contacts')" :key="index"
              >
                {{ item }}
              </td>
            </template> -->

            <template v-if="index == 8">
              <td
                class="text-right"
                v-for="(item, index) in getItems('domains')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 9">
              <td
                class="text-right"
                v-for="(item, index) in getItems('total_phone_lines')" :key="index"
              >
                {{ item }}
              </td>
            </template>           

            <template v-if="index == 10">
              <td
                class="text-right"
                v-for="(item, index) in getItems('email_address')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <!-- <template v-if="index == 10">
              <td
                class="text-right"
                v-for="(item, index) in getItems('warmy')" :key="index"
              >
                {{ item }}
              </td>
            </template> -->

            <!-- <template v-if="index == 11">
              <td
                class="text-right"
                v-for="(item, index) in getItems('servers')" :key="index"
              >
                {{ item }}
              </td>
            </template> -->

            <template v-if="index == 11">
              <td
                class="text-right"
                v-for="(item, index) in getItems('booker_managers_tasks')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <!-- <template v-if="index == 12">
              <td
                class="text-right font-weight-bold"
                v-for="(item, index) in getItems('operating_cost')" :key="index"
              >
                {{ item }}
              </td>
            </template> -->

            <template v-if="index == 12">
              <td
                class="text-right"
                v-for="(item, index) in getItems('booker_call_tasks')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <!-- <template v-if="index == 13">
              <td
                class="text-right font-weight-bold"
                v-for="(item, index) in getItems('profitability')" :key="index"
              >
                {{ item }}
              </td>
            </template> -->

            <template v-if="index == 13">
              <td
                class="text-right"
                v-for="(item, index) in getItems('credits')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 14">
              <td
                class="text-right font-weight-bold"
                v-for="(item, index) in getItems('operating_cost')" :key="index"
              >
                {{ item }}
              </td>
            </template>

            <template v-if="index == 15">
              <td
                class="text-right font-weight-bold"
                v-for="(item, index) in getItems('profitability')" :key="index"
              >
                {{ item }}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import { targetsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from "moment";
import Empty from "@/components/Common/Empty.vue";

export default {
  name: 'Profitability',

  components: {
    LoadingSpinner,
    Empty
  },
  data() {
    return {
      loading: true,
      months:[],
      data: [],
      titles:[
          {id: 1, title: "Total Revenue"},
          {id: 2, title: "Declined Leads"},
          {id: 3, title: "Recovery Leads"},
          {id: 4, title: "Exonerated Leads"},
          {id: 5, title: "Absent Leads"},
          {id: 6, title: "Canceled Leads"},
          {id: 7, title: "Lost Leads"},
          {id: 8, title: "Cashable Revenue"},
          {id: 9, title: "Domains"},
          {id: 10, title: "Phone lines"},
          //{id: 10, title: "Contacts"},
          {id: 11, title: "Email Address"},
          //{id: 12, title: "Warmy"},
          {id: 12, title: "Booker Managers Tasks"},
          //{id: 13, title: "Servers"},
          {id: 13, title: "Booker Call Tasks"},
          
          {id: 14, title: "Credits"},
          {id: 15, title: "Operating Costs"},
          {id: 16, title: "Profitability"}
      ],
      targetData: {
        cashableRevenue:0,
        totalRevenue: 0,
        lostLeads: {
          declinedLeads:0,
          recoveryLeads:0,
          exorenatedLeads:0,
          absentLeads:0,
          canceledLeads:0,
        },
        operatingCosts: {
          //domains: 0,
          contacts: 0,
          emailAddresses: 0,
          warmy: 0,
          servers: 0,
          total_phone_lines: 0,
          booker_managers_tasks: 0,
          booker_call_tasks: 0,
          credits: 0,
        },
        operatingCostsTotal: 0,
        profitability: 0
      }
    };
  },

  props: {
    targetId: {
      type: String,
      required: true
    }
  },

  computed:{

    monthHistory(){
      return (month) => {
        return moment(month).format('YY - MMMM')
      }
    },
    getItems(){
      return (item) => {
        return this.data.map( el => el[item])
      }
    },

    mainTitles() {
      return (item) => {
        if(item == "Total Revenue" ||
           item == "Lost Leads" ||
           item == "Cashable Revenue" ||
           item == "Operating Costs" ||
           item == "Profitability") {
          return 'font-weight-bold'
        }
      }
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData(){
      const completeData = true
      targetsService.getProfitability(this.targetId, completeData)
      .then( res => {
        if(res){
          this.months = res.result.map( el =>({ type: el.col, month: el.sent_date}))
          this.data = res.result
          this.loading = false
        } else {
          this.loading = false
        }
      })
      .catch(err => console.log(err));
    }
  },
};
</script>
